// @ts-check
import * as TrackingService from 'common/services/tracking.service';
import {
  AUTH_FLOWS,
  SESSION_STORAGE_KEYS,
  TRACKING,
  LOCAL_STORAGE_KEYS
} from 'common/constants/constants';
import BrowserStorageAccessor from 'common/utils/BrowserStorageAccessor';
import QueryString from 'query-string';
import { API_GATEWAY_URI } from 'common/constants/api-urls';
const sessionStorageAccessor = BrowserStorageAccessor().session;
const localStorageAccessor = BrowserStorageAccessor().local;

/**
 *
 * @param {string} redirectTo
 * @param {Record<string, string>} [extraParams]
 * @returns {string}
 */
const generateQuery = (redirectTo, extraParams) =>
  redirectTo ? QueryString.stringify({ redirectTo, ...extraParams }) : '';

const generateUrl = ({ providerName, query, isGrant }) =>
  `${API_GATEWAY_URI}/api/v1/rest/public/auth/${
    isGrant ? 'grant' : 'identity'
  }/${providerName}${window.location.search}${
    window.location.search ? '&' : '?'
  }${query}`;

const generateIdentityUrl = (identityName, query = '') =>
  generateUrl({
    providerName: identityName,
    query,
    isGrant: false
  });

export const signIn = (name, redirectUrl = null) => {
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.ONBOARDING,
    page_tab: TRACKING.PAGE_TABS.SIGN_IN,
    click_type: name
  });

  if (!sessionStorageAccessor.get(SESSION_STORAGE_KEYS.AUTH_FLOW)) {
    sessionStorageAccessor.set(
      SESSION_STORAGE_KEYS.AUTH_FLOW,
      AUTH_FLOWS.SIGN_IN
    );
  }
  if (sessionStorageAccessor.get(SESSION_STORAGE_KEYS.SIGN_UP)) {
    sessionStorageAccessor.remove(SESSION_STORAGE_KEYS.SIGN_UP);
  }

  const query = generateQuery(redirectUrl);

  window.location.href = generateIdentityUrl(name, query);
};

/**
 * Redirects the session to the identification endpoint
 * @param {string} name
 * @param {string} redirectUrl
 * @param {boolean} direct
 * @param {Record<string, string>} [queryParams]
 */
export const signUp = (
  name,
  redirectUrl = null,
  direct = false,
  queryParams
) => {
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.ONBOARDING,
    page_tab: TRACKING.PAGE_TABS.SIGN_UP,
    click_type: name,
    ...(direct ? { mode: 'direct' } : {})
  });
  sessionStorageAccessor.set(SESSION_STORAGE_KEYS.SIGN_UP, true);
  const query = generateQuery(redirectUrl, queryParams);
  window.location.href = generateIdentityUrl(name, query);
};

export const linkAccount = (name, isGrant = false) => {
  TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
    page: TRACKING.PAGES.LINK_ACCOUNT,
    click_type: name
  });

  sessionStorageAccessor.set(
    SESSION_STORAGE_KEYS.AUTH_FLOW,
    AUTH_FLOWS.LINK_ACCOUNT
  );
  // @ts-expect-error
  window.location.href = generateUrl({ providerName: name, isGrant });
};

export const getLastLoggedInProviderName = () =>
  BrowserStorageAccessor().local.get(LOCAL_STORAGE_KEYS.LAST_PROVIDER_NAME) ||
  '';

export const getLinkAccountToken = () =>
  localStorageAccessor.get(LOCAL_STORAGE_KEYS.LINK_ACCOUNT_TOKEN);
